/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramChatsUserControllerReadMessagesMutationRequest,
  TelegramChatsUserControllerReadMessagesMutationResponse,
  TelegramChatsUserControllerReadMessagesPathParams,
  TelegramChatsUserControllerReadMessages401,
  TelegramChatsUserControllerReadMessages403,
  TelegramChatsUserControllerReadMessages404,
} from '../../types/TelegramChatsUserControllerReadMessages.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramChatsUserReadMessages } from '../../methods/telegramChatsUserReadMessages.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramChatsUserReadMessagesMutationKey = () =>
  [{ url: '/api/user/telegram/chats/:id/read-messages' }] as const;

export type TelegramChatsUserReadMessagesMutationKey = ReturnType<typeof telegramChatsUserReadMessagesMutationKey>;

/**
 * {@link /api/user/telegram/chats/:id/read-messages}
 */
export function useTelegramChatsUserReadMessages<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramChatsUserControllerReadMessagesMutationResponse,
      ResponseErrorConfig<
        | TelegramChatsUserControllerReadMessages401
        | TelegramChatsUserControllerReadMessages403
        | TelegramChatsUserControllerReadMessages404
      >,
      {
        id: TelegramChatsUserControllerReadMessagesPathParams['id'];
        data: TelegramChatsUserControllerReadMessagesMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramChatsUserControllerReadMessagesMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramChatsUserReadMessagesMutationKey();

  return useMutation<
    TelegramChatsUserControllerReadMessagesMutationResponse,
    ResponseErrorConfig<
      | TelegramChatsUserControllerReadMessages401
      | TelegramChatsUserControllerReadMessages403
      | TelegramChatsUserControllerReadMessages404
    >,
    {
      id: TelegramChatsUserControllerReadMessagesPathParams['id'];
      data: TelegramChatsUserControllerReadMessagesMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return telegramChatsUserReadMessages(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
